// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ContactFormController from "./contact_form_controller"
application.register("contact-form", ContactFormController)

import DataFlowController from "./data_flow_controller"
application.register("data-flow", DataFlowController)

import GlitchController from "./glitch_controller"
application.register("glitch", GlitchController)

import GlowController from "./glow_controller"
application.register("glow", GlowController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import ProjectFormController from "./project_form_controller"
application.register("project-form", ProjectFormController)

import LineItemsController from "./line_items_controller"
application.register("line-items", LineItemsController)

import ExpenseFormController from "./expense_form_controller"
application.register("expense-form", ExpenseFormController)

import ElapsedController from "./elapsed_controller"
application.register("elapsed", ElapsedController)
